import { get, post, patch, deleted, updatePlanDate } from "services";
import routes from "./routes";

const VendorServices = {
  createVendor: async (obj) => {
    const data = await post(routes.createVendor, obj);
    return data;
  },
  getVendorCenter: async (params) => {
    const data = await get(routes.getVendorCenter, params);
    return data;
  },
  getVendorDropdown: async (params) => {
    const data = await get(routes.getVendorDropdown, params);
    return data;
  },
  getShippingRates: async (params) => {
    const data = await get(routes.getShippingRates, params);
    return data;
  },
  getShippingRatesComparison: async (params) => {
    const data = await get(routes.getShippingRatesComparison, params);
    return data;
  },
  updateShippingRate: async (obj) => {
    const data = await patch(routes.updateShippingRate, obj);
    return data;
  },
  UpdateTT: async (obj) => {
    const data = await patch(routes.UpdateTT, obj);
    return data;
  },
  uploadShippingRate: async (obj) => {
    const data = await post(routes.uploadShippingRate, obj);
    return data;
  },
  getTowingRates: async (params) => {
    const data = await get(routes.getTowingRates, params);
    return data;
  },
  getTowingRatesComparison: async (params) => {
    const data = await get(routes.getTowingRatesComparison, params);
    return data;
  },
  updateTowingRate: async (obj) => {
    const data = await patch(routes.updateTowingRate, obj);
    return data;
  },
  uploadTowingRate: async (obj) => {
    const data = await post(routes.uploadTowingRate, obj);
    return data;
  },
  getClearanceRates: async (params) => {
    const data = await get(routes.getClearanceRates, params);
    return data;
  },
  getDamages: async (params) => {
    const data = await get(routes.getDamages, params);
    return data;
  },
  getClearanceRatesComparison: async (params) => {
    const data = await get(routes.getClearanceRatesComparison, params);
    return data;
  },
  updateClearanceRate: async (obj) => {
    const data = await patch(routes.updateClearanceRate, obj);
    return data;
  },
  uploadClearanceRate: async (obj) => {
    const data = await post(routes.uploadClearanceRate, obj);
    return data;
  },
  getVendorCosting: async (params) => {
    const data = await get(routes.getVendorCosting, params);
    return data;
  },
  updateVendorCosting: async (obj) => {
    const data = await patch(routes.updateVendorCosting, obj);
    return data;
  },
  createTT: async (obj) => {
    const data = await post(routes.createTT, obj);
    return data;
  },
  getTT: async (params) => {
    const data = await get(routes.getTT, params);
    return data;
  },
  getTTDetail: async (params) => {
    const data = await get(routes.getTTDetail, params);
    return data;
  },
  getTTPreview: async (params) => {
    const data = await get(routes.getTTPreview, params);
    return data;
  },
  applyFund: async (obj) => {
    const data = await post(routes.applyFund, obj);
    return data;
  },
  quickClearanceApply: async (obj) => {
    const data = await post(routes.quickClearanceApply, obj);
    return data;
  },
  getQuickClearanceList: async (params) => {
    const data = await get(routes.quickClearanceList, params);
    return data;
  },
  updateQuickClearancePayment: async (obj) => {
    const data = await patch(routes.quickClearanceUpdate, obj);
    return data;
  },
  CreateDamage: async (obj) => {
    const data = await post(routes.CreateDamage, obj);
    return data;
  },
  getVendorFundApproval: async (params) => {
    const data = await get(routes.getVendorFundApproval, params);
    return data;
  },
  approveRejectStatus: async (obj) => {
    const data = await post(routes.approveRejectStatus, obj);
    return data;
  },
  getVendorAppliedFunds: async (params) => {
    const data = await get(routes.getVendorAppliedFunds, params);
    return data;
  },
  getVendorAppliedFundsDetail: async (params) => {
    const data = await get(routes.getVendorAppliedFundsDetail, params);
    return data;
  },
  getDamageDetail: async (params) => {
    const data = await get(routes.getDamageDetail, params);
    return data;
  },
  getDamagePreview: async (params) => {
    const data = await get(routes.getDamagePreview, params);
    return data;
  },
  deleteVendorsFundsApplied: async (params) => {
    const data = await patch(routes.deleteVendorsFundsApplied, params);
    return data;
  },
  getShippings: async (params) => {
    const data = await get(routes.getShippings, params);
    return data;
  },
  getShippingRatesCheapset: async (params) => {
    const data = await get(routes.getShippingRatesCheapset, params);
    return data;
  },
  getTowingRatesCheapset: async (params) => {
    const data = await get(routes.getTowingRatesCheapset, params);
    return data;
  },
  createPlan: async (obj) => {
    const data = await post(routes.createPlan, obj);
    return data;
  },
  getCreatePlan: async (params) => {
    const data = await get(routes.getCreatePlan, params);
    return data;
  },

  updateVendorDate: async (obj) => {
    const data = await updatePlanDate(routes.updatePlanDate, obj);
    return data;
  },
  deletePlan: async (params) => {
    const data = await deleted(routes.deletePlan, params);
    return data;
  },
  updatePlan: async (params) => {
    const data = await patch(routes.updatePlan, params);
    return data;
  },

  startBot: async () => {
    const data = await post(routes.startBot);
    return data;
  },
  uploadVendorInvoice: async (obj) => {
    const data = await post(routes.uploadVendorInvoice, obj);
    return data;
  },
  getUploadedVendorInvoices: async (params) => {
    const data = await get(routes.getUploadedVendorInvoices, params);
    return data;
  },
  getDamagesDetail: async (params) => {
    const data = await get(routes.getDamagesDetail, params);
    return data;
  },
  getDamages: async (params) => {
    const data = await get(routes.getDamages, params);
    return data;
  },
  updateDamages: async (params) => {
    const data = await patch(routes.updateDamages, params);
    return data;
  },
  createDamages: async (params) => {
    const data = await post(routes.createDamages, params);
    return data;
  },
  updateClaim: async (params) => {
    const data = await patch(routes.updateClaim, params);
    return data;
  },
  deleteDamage: async (params) => {
    const data = await deleted(routes.deleteDamage, {}, params);
    return data;
  },
  addMiscVendor: async (params) => {
    const data = await patch(routes.addMiscVendor, params);
    return data;
  },
};

export default VendorServices;
